export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-enabled-960-e528d42233787e276151723006459ddd.png";